import { Component } from '@angular/core';
import { TITLE_SEARCH_MATTER_STATE } from '@models/matter';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterActions } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';
import { NavigationService } from '@services/nav/nav.service';
import { TestHooks } from './no-pin.hooks';

@Component({
	selector: 'app-teranet-no-pin',
	templateUrl: './no-pin.component.html',
	standalone: false,
})
export class TeranetNoPinComponent {
	testHooks = TestHooks;
	public ICON = ICON;

	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(private routeService: NavigationService) {}

	@Dispatch()
	updateSaleStateTitleSearch(
		matterId: string,
		state: TITLE_SEARCH_MATTER_STATE,
	): MatterActions.SetSaleStateTitleSearch {
		return new MatterActions.SetSaleStateTitleSearch({
			matterId,
			titleSearchState: state,
		});
	}

	goToTitleSearch(): void {
		this.updateSaleStateTitleSearch(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.SEARCH,
		);
		this.routeService.goToMatter_TitleSearch_Stepper_Search(this.matterId);
	}
}
